"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var Undo = function Undo(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: '0 0 275.979 275.979'
  }, props), /*#__PURE__*/_react["default"].createElement('g', null, /*#__PURE__*/_react["default"].createElement('path', {
    d: 'm154.171,16.181c-58.834,0-107.156,40.58-118.972,95.585l-18.497-31.2c-3.48-5.22-8.701-5.22-12.181-3.48-5.22,3.48-5.22,8.701-3.48,12.181l33.062,53.944c1.74,1.74 3.48,3.48 5.22,3.48h1.74c1.74,0 3.48,0 5.22,1.74l53.944-33.062c5.22-3.48 5.22-8.701 3.48-12.181-3.48-5.22-8.701-5.22-12.181-3.48l-40.684,24.101c6.995-50.759 50.707-90.225 103.328-90.225 57.424,0 104.407,46.983 104.407,104.407s-46.983,104.406-104.407,104.406c-5.22,0-8.701,3.48-8.701,8.701s3.48,8.701 8.701,8.701c67.865,0 121.808-53.944 121.808-121.808 0.002-67.866-53.942-121.81-121.807-121.81z'
  })));
};
/* eslint-enable */
var _default = Undo;
exports["default"] = _default;